import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/courses/:courseId/grade/:userId',
        component: () => import('@/pages/courses/student/student-grade/StudentGrade.vue'),
        props: true,
        children: [
            {
                name: 'student-grade-view',
                path: '',
                component: () => import('@/components/student/student-grade/StudentGradeView.vue'),
                meta: {
                    title: 'Student Grade',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'grade' },
                },
            },
        ],
    },
];
